import { render } from "./ReferencesTempPage.vue?vue&type=template&id=4933e664"
import script from "./ReferencesTempPage.vue?vue&type=script&lang=js"
export * from "./ReferencesTempPage.vue?vue&type=script&lang=js"
script.render = render

export default script